export default __webpack_public_path__ + "locales/lv/Common.json?hash=057336c0a6f8c394b24204b5f287218f";